import type { UserProfile } from '../stores/user';

export function canAccessRoute(path: string, role: UserProfile['user_type'] | null | undefined): boolean {
  const pathname = path.replace(/^#/, '').split('?')[0];
  if (pathname === '/installer/jobs') return role === 'installer' || role === 'system_admin';
  if (role === 'installer' && !['/', '/profile', '/devices', '/installer/jobs'].includes(pathname) && !/^\/devices\/[^/]+$/.test(pathname)) return false;
  if (role === 'property_manager') {
    if (pathname === '/properties' || /^\/properties\/[^/]+$/.test(pathname) || pathname === '/alerts') {
      return true;
    }
  }
  return !!role && (!(pathname === '/admin' || pathname.startsWith('/admin/')) || role === 'system_admin');
}

export function deviceHref(eui: unknown): string | undefined {
  return typeof eui === 'string' && /^[0-9a-f]{16}$/i.test(eui.trim())
    ? `#/devices/${encodeURIComponent(eui.trim())}` : undefined;
}

export function alertsHref(role: UserProfile['user_type'] | null | undefined): string {
  return role === 'system_admin' ? '#/admin/alerts' : '#/devices';
}
